export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: that.disabled ? 80 : 110,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_fileName') || '文档名称',
    field: 'fileName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 250,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_remark') || '文档说明',
    field: 'remark',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    editRender: {
      name: 'ElInput',
      props: {
        maxlength: 250,
        showWordLimit: true,
      },
    },
  },
  {
    title: that.$l('INDEX.order_doc_uploadByName') || '上传人',
    field: 'uploadByName',
    align: 'center',
    width: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.order_doc_uploadTime') || '上传时间',
    field: 'uploadTime',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
  },
]
